"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * ChiRhos API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class UserApi extends runtime.BaseAPI {
    /**
     * Registers a device for the user for push operations
     */
    apiUserDeviceRegisterPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.deviceInstallation === null || requestParameters.deviceInstallation === undefined) {
                throw new runtime.RequiredError('deviceInstallation', 'Required parameter requestParameters.deviceInstallation was null or undefined when calling apiUserDeviceRegisterPost.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/User/Device/Register`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.DeviceInstallationToJSON(requestParameters.deviceInstallation),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Registers a device for the user for push operations
     */
    apiUserDeviceRegisterPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiUserDeviceRegisterPostRaw(requestParameters);
        });
    }
    /**
     * Unregisters a device for the user for push operations
     */
    apiUserDeviceUnregisterPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.deviceInstallation === null || requestParameters.deviceInstallation === undefined) {
                throw new runtime.RequiredError('deviceInstallation', 'Required parameter requestParameters.deviceInstallation was null or undefined when calling apiUserDeviceUnregisterPost.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/User/Device/Unregister`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.DeviceInstallationToJSON(requestParameters.deviceInstallation),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Unregisters a device for the user for push operations
     */
    apiUserDeviceUnregisterPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiUserDeviceUnregisterPostRaw(requestParameters);
        });
    }
    /**
     * This does not delete the entity, but removes it from the favourites
     */
    apiUserFavouriteDeleteRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.entityId !== undefined) {
                queryParameters['entityId'] = requestParameters.entityId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/User/Favourite`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * This does not delete the entity, but removes it from the favourites
     */
    apiUserFavouriteDelete(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiUserFavouriteDeleteRaw(requestParameters);
        });
    }
    /**
     */
    apiUserFavouriteListGetRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/User/Favourite/List`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IEntityIStorableIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiUserFavouriteListGet() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiUserFavouriteListGetRaw();
            return yield response.value();
        });
    }
    /**
     */
    apiUserGetForPersonPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/User/GetForPerson`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRawRequestToJSON(requestParameters.apiEntityRawRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IUserIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiUserGetForPersonPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiUserGetForPersonPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiUserGetSelfGetRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/User/GetSelf`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IUserIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiUserGetSelfGet() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiUserGetSelfGetRaw();
            return yield response.value();
        });
    }
    /**
     * ChiRhos Owners only
     */
    apiUserListAllSummaryGetRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/User/ListAllSummary`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.UserSummaryIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * ChiRhos Owners only
     */
    apiUserListAllSummaryGet() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiUserListAllSummaryGetRaw();
            return yield response.value();
        });
    }
    /**
     */
    apiUserSetGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.userEntityId !== undefined) {
                queryParameters['userEntityId'] = requestParameters.userEntityId;
            }
            if (requestParameters.isTenantAdmin !== undefined) {
                queryParameters['isTenantAdmin'] = requestParameters.isTenantAdmin;
            }
            if (requestParameters.isTenantOwner !== undefined) {
                queryParameters['isTenantOwner'] = requestParameters.isTenantOwner;
            }
            if (requestParameters.isChiRhosOwner !== undefined) {
                queryParameters['isChiRhosOwner'] = requestParameters.isChiRhosOwner;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/User/Set`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IUserIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiUserSetGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiUserSetGetRaw(requestParameters);
            return yield response.value();
        });
    }
}
exports.UserApi = UserApi;
